import { Popover } from '@nextui-org/react';
import styled, { css } from 'styled-components';

import { PenIcon } from '../../assets';
import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';
import { Avatar } from '..';
import IconButton from '../Button/IconButton';

interface StyledAvatarContainerProps {
  avatarSize: string;
}

export const AvatarContainer = styled.div<StyledAvatarContainerProps>`
  display: flex;
  position: relative;
  width: ${(props: StyledAvatarContainerProps) => props.avatarSize};
  height: ${(props: StyledAvatarContainerProps) => props.avatarSize};
`;

interface StyledAvatarProps {
  squared?: boolean;
}
export const StyledAvatar = styled(Avatar).attrs((props: any) => ({
  ...props,
  borderRadius: props.squared ? '0.25rem' : '50%',
  fontSize: props.fontSize || '4.5rem',
}))`
  background: ${(props: ThemeProp) => props.theme.colors.main.c100};
  width: 100%;
  height: 100%;

  .nextui-avatar-text {
    color: ${(props: ThemeProp) => props.theme.colors.main.c600};
  }
  z-index: ${ZIndexLayers.elevateOne};
`;

export const LoadingWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  z-index: ${ZIndexLayers.overlay};
`;

export const EditIcon = styled(PenIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.primary.c050};
  width: 0.875rem;
  height: 0.875rem;
`;

const EditAvatarButtonCommon = css`
  background-color: ${(props: ThemeProp) => props.theme.colors.black};
  filter: drop-shadow(0px 1px 4px rgba(41, 12, 55, 0.1));
  width: 1.5rem;
  height: 1.5rem;
  &:hover {
    svg {
      stroke: ${(props: ThemeProp) => props.theme.colors.main.c600};
    }
  }
`;

export const EditAvatarButton = styled(IconButton)<StyledAvatarProps>`
  position: absolute;
  top: 1.375rem;
  left: 3.5rem;
  border-radius: ${(props) => (props.squared ? '0.375rem' : '50%')};
  z-index: ${ZIndexLayers.overlay};
  ${EditAvatarButtonCommon};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    left: 4rem;
  }
`;

export const ImgPlaceholderContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const StyledPopoverContent = styled(Popover.Content)`
  border-radius: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.menu};
  padding: 0.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    box-shadow: 0rem 0.188rem 0.5rem 0rem #1d0c3740; // Design specs
    margin-top: -0.5rem;
  }
`;

interface ItemProps {
  $isDestructive?: boolean;
}

export const Item = styled.div<ItemProps>`
  padding: 0.5rem 0.625rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: 1.1375rem;
  color: ${(props: ThemeProp & ItemProps) =>
    props.$isDestructive ? props.theme.colors.system.error : props.theme.colors.neutrals.c800};
  border-radius: 0.375rem;
  cursor: pointer;

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.main.c050};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    line-height: 2rem;
    font-size: ${(props: ThemeProp) => props.theme.fontSize.ml};
  }
`;

export const BodyText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.high};
  padding-bottom: 0.75rem;
`;
